import { AppDispatch } from "../../../../store";
import { RootState } from "../../../../store/types";
import { connect } from "react-redux";
import CurrentPlanSummary from "./CurrentPlanSummary";
import { GetShiftPlanOutputRequest } from "../../../reviewAndPublish/model";
import { getShiftPlanOutputThunk } from "../../../../store/slices/reviewAndPublishSlice";
import { SPMSGetShiftPlanResponse } from "../../../../types/shiftPlan";
import { showError } from "../../../../store/slices/errorSlice";
import { PostPublishView } from "../../../../store/slices/v2/publishedShiftPlanFeatureSlice";

// Define the props that come directly from parent (not from Redux). selectedTab,
// postPublishView, onNeedsTakeOver and onPlanSuccess are consumed by the page but
// not remapped — connect merges own props through to the component by default.
// postPublishView is passed down (not read from Redux) so the home host can clear
// the one-shot pointer immediately without racing this gated mount.
interface OwnProps {
    shiftPlans: SPMSGetShiftPlanResponse[];
    selectedTab: string;
    selectedDate: string;
    selectedShift: string;
    postPublishView?: PostPublishView | null;
    onNeedsTakeOver: (displayMessage: string) => void;
    onPlanSuccess: (planId: string) => void;
}

const mapStateToProps = (state: RootState, ownProps: OwnProps) => ({
    shiftPlans: ownProps.shiftPlans, // Pass through the shiftPlans from parent
    selectedDate: ownProps.selectedDate,
    selectedShift: ownProps.selectedShift,
    planId: state.shiftPlan.planId,
    stationCode: state.shiftPlan.stationCode,
    // The header reads shiftPlanOutput for the plan-summary text (id, overrides
    // count) and the plan-status validation effect, so it's mapped here.
    shiftPlanOutput: state.reviewAndPublish.shiftPlanOutput,
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
    getShiftPlanOutput: (getShiftPlanOutputRequest: GetShiftPlanOutputRequest) => dispatch(getShiftPlanOutputThunk(getShiftPlanOutputRequest)),
    showError: (errorPayload: { title: string; message: string }) => dispatch(showError(errorPayload))
});

export default connect(mapStateToProps, mapDispatchToProps)(CurrentPlanSummary);
